<div fxLayout="row" class="background">
    <div fxFlex="80" fxFlexOffset="10%">
  
      <section id="header">
        <h1 class="h1Header">EDITAR PEDIDO ACTIVO</h1>
      </section>

      <form [formGroup]="editOrderForm">
        <mat-card>
            <h3 class="cardHeader">Detalles de usuario</h3>
          <div fxLayout="row" fxLayoutAlign="space-evenly center" fxLayoutGap="0.5rem">
            <div fxFlex="50">
              <mat-form-field appearance="outline">
                <mat-label>Comercio</mat-label>
                <mat-select>
                    <mat-option value="one">Restaurante 1</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div fxFlex="50">
              <mat-form-field appearance="outline">
                <mat-label>Teléfono</mat-label>
                <input type="number" matInput formControlName="telefono">
                <mat-error *ngIf="editOrderForm.controls['usuario'].hasError('required')">
                  Este campo es obligatorio
                </mat-error>
              </mat-form-field>              
            </div>
          </div>
          <div fxLayout="row" fxLayoutAlign="space-evenly center" fxLayoutGap="0.5rem">
            <div fxFlex="50">
              <mat-form-field appearance="outline">
                <mat-label>Nombre de usuario</mat-label>
                <input type="text" matInput formControlName="usuario">
                <mat-error *ngIf="editOrderForm.controls['usuario'].hasError('required')">
                  Este campo es obligatorio
                </mat-error>
              </mat-form-field>
            </div>
            <div fxFlex="50">
              <mat-form-field appearance="outline">
                <mat-label>Dirección</mat-label>
                <input type="text" matInput formControlName="direccion">
                <mat-error *ngIf="editOrderForm.controls['direccion'].hasError('required')">
                  Este campo es obligatorio
                </mat-error>
              </mat-form-field>              
            </div>
          </div>
        </mat-card>
        <mat-card>
            <h3 class="cardHeader">Detalles del Pedido</h3>
          <div fxLayout="row" fxLayoutAlign="space-evenly center" fxLayoutGap="0.5rem">
            <div fxFlex="29">
              <mat-form-field appearance="outline">
                <mat-label>Seleccionar artículo</mat-label>
                <mat-select>
                    <mat-option value="one">Hamburguesa</mat-option>
                    <mat-option value="two">Chocotorta</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div fxFlex="29">
              <mat-form-field appearance="outline">
                <mat-label>Seleccionar unidad</mat-label>
                <mat-select>
                    <mat-option value="one">Chico</mat-option>
                    <mat-option value="two">Mediano</mat-option>
                    <mat-option value="two">Grande</mat-option>
                </mat-select>
              </mat-form-field>              
            </div>
            <div fxFlex="29">
              <mat-form-field appearance="outline">
                <mat-label>Cantidad</mat-label>
                <input type="text" matInput formControlName="cantidad">
                
              </mat-form-field>
              <button fxFlex="13" mat-mini-fab class="btnDelete">
                <mat-icon>delete</mat-icon>
            </button>
            </div>
          </div>
          <button mat-raised-button class="addArt">Agregar Artículo</button>
         </mat-card>
        <div fxLayout="row" fxLayoutAlign="start center">
            <button type="submit" mat-raised-button class="save-changes">GUARDAR CAMBIOS</button>
          </div>
        </form>



    </div>
</div>

